export default __webpack_public_path__ + "static/media/Gauntlets of the Assailant.a9fc34f4.jpg";